<template>
  <div class="flex">
    <CountdownItemControl
      v-bind:value="String(countdown.days)"
      v-bind:title="lang('lbl_0000114')"
    />
    <CountdownItemControl
      v-bind:value="String(countdown.hours)"
      v-bind:title="lang('lbl_0000115')"
    />
    <CountdownItemControl
      v-bind:value="String(countdown.minutes)"
      v-bind:title="lang('lbl_0000116')"
    />
    <CountdownItemControl
      v-bind:value="String(countdown.seconds)"
      v-bind:title="lang('lbl_0000117')"
      last
    />
  </div>
</template>

<script>
import CountdownItemControl from "./CountdownItemControl.vue";
import mixin from "./../../mixin.js";
export default {
  name: "v-special-countdown", // Improved version of CountdownControl for Special GA
  mixins: [mixin],
  components: {
    CountdownItemControl,
  },
  props: {
    date: {
      type: [String, null],
      default: null,
    },
  },
  mounted() {
    this.interval = setInterval(this.updateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  data() {
    return {
      current_datetime: new Date(),
    };
  },
  computed: {
    countdown() {
      const now = this.current_datetime.getTime();
      const target = this.date
        ? new Date(this.date.replace(" ", "T")).getTime()
        : this.current_datetime.getTime();
      const remaining_time = target - now;

      if (remaining_time <= 0) {
        return {
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        };
      }

      const days = Math.floor(remaining_time / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (remaining_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (remaining_time % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remaining_time % (1000 * 60)) / 1000);

      return {
        days: this.formatTime(days),
        hours: this.formatTime(hours),
        minutes: this.formatTime(minutes),
        seconds: this.formatTime(seconds),
      };
    },
  },
  methods: {
    formatTime(time) {
      return time < 10 ? `0${time}` : time;
    },
    updateTime() {
      this.current_datetime = new Date();
    },
  },
};
</script>

<style></style>
